var DAYS_OF_THE_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
var HOUR_23_59 = 1439;
var MIDNIGHT = 1440;
var MINUTES_IN_A_DAY = 1440;
var NOON = 720;
var TIME_FORMAT_DISPLAY = 'HH:mm';
var TIME_FORMAT_SERVER = 'h:mm A';
export { DAYS_OF_THE_WEEK, HOUR_23_59, MIDNIGHT, MINUTES_IN_A_DAY, NOON, TIME_FORMAT_DISPLAY, TIME_FORMAT_SERVER };